"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerToV2 = void 0;
function answerToV2(answer) {
    var id = answer.questionId, text = answer.textAnswer;
    return { id: id, text: text };
}
exports.answerToV2 = answerToV2;
//# sourceMappingURL=AnswerAdapter.js.map